export default "__VITE_ASSET__48abd326__"